__turbopack_context__.v({
  "disclaimer": "Disclaimer-module-scss-module__0CQCjW__disclaimer",
  "fade-in": "Disclaimer-module-scss-module__0CQCjW__fade-in",
  "no-transform": "Disclaimer-module-scss-module__0CQCjW__no-transform",
  "rotate": "Disclaimer-module-scss-module__0CQCjW__rotate",
  "toneText": "Disclaimer-module-scss-module__0CQCjW__toneText",
});
